import React from "react";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { AccordionProps } from "@mui/material";
import * as S from "./styles";

interface IKogAccordionProps {
	header: React.ReactNode | string;
	content: React.ReactNode | string;
	propsRootAccordion?: Omit<AccordionProps, "children">;
}
function KogAccordion({ header, content, propsRootAccordion = {} }: IKogAccordionProps) {
	return (
		<S.ContainerAccordion {...propsRootAccordion}>
			<S.AccordionSummary
				id="id-accordion-history"
				aria-controls="categories-content"
				expandIcon={<ExpandMore fontSize="medium" />}
			>
				{header}
			</S.AccordionSummary>
			<S.AccordionDetails>{content}</S.AccordionDetails>
		</S.ContainerAccordion>
	);
}

export default KogAccordion;
